// extracted by mini-css-extract-plugin
export default {"signUpForm":"style_signUpForm__ctn7b","p":"style_p__+y6gB","span":"style_span__KTPg2","alert":"style_alert__y772r"};